import type { NodeTypes } from "@xyflow/react";
import TriggerNode from "./TriggerNode";
import ActionNode from "./ActionNode";
import DelayNode from "./DelayNode";
import BranchNode from "./BranchNode";
import WorkflowGroupNode from "./WorkflowGroupNode";
import PipelineGroupNode from "./PipelineGroupNode";
import StageNode from "./StageNode";
import FormNode from "./FormNode";

export const nodeTypes: NodeTypes = {
  trigger: TriggerNode,
  action: ActionNode,
  delay: DelayNode,
  branch: BranchNode,
  workflowGroup: WorkflowGroupNode,
  pipelineGroup: PipelineGroupNode,
  stage: StageNode,
  form: FormNode,
};
